module.exports = __webpack_public_path__ + "static/media/generator.a43452b9.svg";